import { Box, Drawer, DrawerProps, IconButton, List, ListItem, Stack, Typography, useTheme } from '@mui/material'
import { FC } from 'react'
import { WaterInfoActions } from '../../store/waterInfo'
import CloseIcon from '@mui/icons-material/Close'

import { useStyles } from '../../theme'
import { useDispatch, useSelector } from 'react-redux'
import { WaterInfoSelectors } from '../../store/waterInfo/waterinfo.selectors'
import { SippMarkdown } from '../SIPPMarkdown'

export const WaterInfoDrawer:FC<DrawerProps> = (props) => {
  const theme = useTheme()
  const styles = useStyles()
  const markdown = useSelector(WaterInfoSelectors.makeWaterInfoMarkdownByName)
  const selectedWaterParameter = useSelector(WaterInfoSelectors.getSelectedWaterParameter)
  const open = useSelector(WaterInfoSelectors.getIsOpen)
  const dispatch = useDispatch()

  return (
    <Drawer
      anchor="right"
      sx={{zIndex:1300}}
      open={open}
      {...props}
    >
      <Box
        sx={{

          padding:"8px 24px",
          maxHeight:"100vh",
          display:'flex',
          overflow:'hidden',
          whiteSpace: 'break-spaces',
          flexDirection:'column'}}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          borderBottom={`1px solid ${theme.palette.divider}`}
          pb={2}
          sx={{ flexShrink: 1, }}
        >
          <Typography fontWeight="bold" color="primary.dark" fontSize={'1.2rem'}>
            {selectedWaterParameter}
          </Typography>
          <IconButton onClick={()=>{
            dispatch(WaterInfoActions.toggleIsOpen())
          }}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <Box sx={{overflowY: 'auto', flex:'1 1 auto', width:'100%',whiteSpace:'break-spaces', ...styles.scrollbar}}>
          <SippMarkdown>{markdown}</SippMarkdown>
        </Box>
      </Box>
    </Drawer>
  )
}